import React, {useEffect, useState} from "react";
import s from "./Header.module.css"
// import UserWrapper from "./User/UserWrapper";
import StoreContainer from "./Store/StoreContainer";
import PrintOptionsWrapper from "../Content/PrintOptions/PrintOptionsWrapper";


const Header = (props) => {

    const [supplier, setSupplier] = useState('');
    const [product, setProduct] = useState('');

    useEffect(() => {
        if(props.data.contentData.isActivePromosScreen){
            props.setProductCategoryPromosDispatcher(product);
        } else {
            props.setProductCategoryPricesDispatcher(product);
        }
    }, [product]);
    useEffect(() => {
        if(props.data.contentData.isActivePromosScreen){
            props.setSupplierPromosDispatcher(supplier);
        } else {
            props.setSupplierPricesDispatcher(supplier);
        }
    }, [supplier]);

    return (
        <div className={s.header}>
            <div className={s.dataWrapper}>
                {/*<UserWrapper/>*/}
                <StoreContainer
                    supplier={supplier}
                    product={product}
                />
                <PrintOptionsWrapper
                    data={props.data.contentData.isActivePromosScreen ? props.data.contentData.data : props.data.contentData.dataForRegPrices}
                    format={props.data.dropdownsReducer.format}
                    selectedIds={props.data.contentData.selectedIds}
                    onDownload={props.getDataForDownload}
                    onDownloadRegItems={props.getDataForDownloadRegItems}
                    setFormat={props.setFormat}
                    dataForPrint={props.data.contentData.dataPrint}
                    sendSaleIds={props.sendSaleIdsToServer}
                    sendEffectiveBarCodes={props.sendEffectiveBarCodesToServer}
                    changeSelectedIds={props.changeSelectedIds}
                    setDataPrintStatus={props.setDataPrintStatus}
                    isDataPrintForButton={props.data.contentData.isDataPrintForButton}
                    isActivePromotionScreen={props.data.contentData.isActivePromosScreen}
                    productCategoryNames={props.data.contentData.ProductCategoryNames}
                    supplierNames={props.data.contentData.SupplierNames}
                    dropDownValues={props.data.dropdownsReducer}
                    getDataTable={props.getDataTable}
                    getDataTableForRegularPrices={props.getDataTableForRegularPrices}
                    setPreloader={props.setPreloader}
                    supplier={supplier}
                    product={product}
                    setSupplier={setSupplier}
                    setProduct={setProduct}
                />
            </div>
        </div>
    )
};

export default Header;